export default __webpack_public_path__ + "static/media/cothan.cf52946c.png";